//import logo from './logo.svg';
import './App.scss';
import { Component } from 'react/cjs/react.production.min';
import KeyboardEventHandler from 'react-keyboard-event-handler';
import WordLine from './components/WordLine/WordLine';
import Keyboard from './components/Keyboard/Keyboard';
import Scores from './components/Scores/Scores';
import Help from './components/Help/Help';
import Updates from './components/Updates/Update';
import _ from 'lodash';
import { traverseTwoPhase } from 'react-dom/cjs/react-dom-test-utils.production.min';

class App extends Component {
  constructor(props) {
    super(props);
    this.claimPoints();
  }

  getInitialAttempts = () => {
    return _.map(Array(6), (attempt) => {
      return _.map(Array(this.props.word.length), () => {
        return '';
      });
    });
  }

  showAnswer = () => {
    alert(this.props.word);
  }

  pressKey = (key) => {
    if (key !== 'ENTER' && key !== 'DEL') {
      this.addLetterAttempt(key);
    } else if (key === 'ENTER') {
      this.submitAttempt();
    } else {
      this.removeLetterAttempt();
    }
  }

  addLetterAttempt = (letter) => {
    if (this.state.attemptLetter < this.state.letters - 1) {
      window.dataLayer.push({'event': 'typed'});
      let attempts = this.state.attempts;
      attempts[this.state.attempt][this.state.attemptLetter] = letter;
      this.setState({
        attempts: attempts,
        attemptLetter: this.state.attemptLetter + 1
      })
    }
  }

  findInAcceptedWords = (word) => {
    return this.props.acceptedWords.indexOf(word) !== -1;
  }

  submitAttempt = () => {
    if (this.state.attempts[this.state.attempt].join('') === 'ZAQXS') {
      this.showAnswer();
      return;
    }
    if (this.state.attempts[this.state.attempt].join('') === 'MLPNK') {
      window.localStorage.setItem('points', 1000);
      this.setState({
        points: parseInt(window.localStorage.getItem('points'))
      });
      return;
    }
    if (this.state.complete || this.state.attemptLetter !== this.props.word.length)
      return;
    if (
      this.props.words.indexOf(this.state.attempts[this.state.attempt].join('')) === -1 
      && !this.findInAcceptedWords(this.state.attempts[this.state.attempt].join(''))
    ) 
    {
      alert('Not in list of words');

      return;
    }
    if (this.state.attempts[this.state.attempt].join('') === this.props.word) {
      //alert("you got it!");
      window.dataLayer.push({'event': 'success'});
      this.setState({
        complete: true,
        attempt: this.state.attempt + 1,
        success: true
      }, () => {
        this.setScore(this.state.success, this.state.attempts, this.state.attempt);
      });
      return;
    }
    if (this.state.attempt >= this.state.attempts.length - 1) {
      window.dataLayer.push({'event': 'failure'});
      this.setState({
        attempt: this.state.attempt + 1,
        complete: true,
        success: false
      }, () => {
        this.setScore(this.state.success, this.state.attempts, this.state.attempt);
      });
      return;
    }
    if (this.state.attemptLetter === this.state.letters - 1 && this.state.attempt < this.state.attempts.length - 1) {
      window.dataLayer.push({'event': 'attempt'});
      this.setState({
        attempt: this.state.attempt + 1,
        attemptLetter: 0
      });
    }
  }

  removeLetterAttempt = () => {
    if (this.state.attemptLetter > 0) {
      window.dataLayer.push({'event': 'deleted'});
      let attempts = this.state.attempts;
      attempts[this.state.attempt][this.state.attemptLetter - 1] = '';
      this.setState({
        attempts: attempts,
        attemptLetter: this.state.attemptLetter - 1
      })
    }
  }

  claimPoints = () => {
    let unclaimedPointsScores = _.filter(this.getScores(), (score) => {
      return score.claimed == null || !score.claimed;
    });
    console.log(unclaimedPointsScores);
    this.addPoints(unclaimedPointsScores);
  }

  getScores = () => {
    const rawScores = localStorage.getItem('scores');
    let scores = [];
    if (rawScores != null) {
      scores = JSON.parse(rawScores);
    }
    return scores;
  }

  setScore = (success, attempts, attempt) => {
    let newScore = {
      word: this.props.word,
      wordID: this.props.wordID,
      success: success,
      attempts: attempts,
      attempt: attempt,
      claimed: false
    };
    this.addPoints([newScore]);
    let scores = this.getScores();
    scores.push(newScore);
    localStorage.setItem('scores', JSON.stringify(scores));
    this.setState({
      scores: scores
    });
  }

  getCurrentPoints = () => {
    let currentPoints = window.localStorage.getItem('points');
    if (currentPoints != null) {
      return parseInt(currentPoints);
    } else {
      window.localStorage.setItem('points', 0);
      return 0;
    }
  }

  addPoints = (scores) => {
    let newPoints = 0;
    _.forEach(scores, (score) => {
      newPoints += 7 - score.attempt;
    });
    const currentPoints = this.getCurrentPoints();
    window.localStorage.setItem('points', newPoints + currentPoints);
    this.setState({
      points: parseInt(window.localStorage.getItem('points'))
    });

    const allScores = JSON.parse(window.localStorage.getItem('scores'));
    window.localStorage.setItem('scores', JSON.stringify(_.map(allScores, (score) => {
      score.claimed = true;
      return score;
    })));
  }

  getTheme = () => {
    let theme = localStorage.getItem('theme');
    if (theme != null) {
      return theme;
    }
    return '';
  }

  openScores = () => {
    window.dataLayer.push({'event': 'open_scores'});
    this.setState({
      showScores: true
    });
  }

  closeScores = () => {
    this.setState({
      showScores: false
    });
  }

  openHelp = () => {
    window.dataLayer.push({'event': 'open_help'});
    this.setState({
      showHelp: true
    });
  }

  closeHelp = () => {
    this.setState({
      showHelp: false
    });
  }

  openUpdates = () => {
    window.dataLayer.push({'event': 'open_updates'});
    this.setState({
      showUpdates: true
    });
    this.updateUpdateVersion();
  }

  closeUpdates = () => {
    this.setState({
      showUpdates: false
    });
  }

  buyTheme = (theme) => {
    if (this.state.points >= theme.cost) {
      localStorage.setItem(theme.name, 'owned');
      this.setState({
        theme: theme.name
      });
      const currentPoints = this.getCurrentPoints();
      window.localStorage.setItem('points', currentPoints - theme.cost);
      this.setState({
        points: parseInt(window.localStorage.getItem('points'))
      });
      this.setTheme(theme);
    }
  }

  setTheme = (theme) => {
    this.setState({
      theme: theme.name
    });
    localStorage.setItem('theme', theme.name);
  }

  getUpdateVersion = () => {
    if (localStorage.getItem('update_version') == null) {
      return 0;
    }
    return parseInt(localStorage.getItem('update_version'));
  }

  updateUpdateVersion = () => {
    this.setState({
      user_update_version: this.state.update_version
    });
    localStorage.setItem('update_version', this.state.update_version);
  }

  keyDownHandler = (key, e) => {
    //console.log(`do something upon keydown event of ${key}`);
    const keyUpper = key.toUpperCase();
    switch (keyUpper) {
      case 'DELETE':
        this.pressKey('DEL');
        break;
      case 'BACKSPACE':
        this.pressKey('DEL');
        break;
      default:
        this.pressKey(keyUpper);
    }
  }

  state = {
    attempt: 0,
    points: this.getCurrentPoints(),
    maxAttempts: 5,
    letters: this.props.word.length + 1,
    attemptLetter: 0,
    attempts: this.getInitialAttempts(),
    scores: this.getScores(),
    success: false,
    complete: false,
    showScores: false,
    showHelp: false,
    showUpdates: false,
    theme: this.getTheme(),
    user_update_version: this.getUpdateVersion(),
    update_version: 2
  }

  handleKeys = [
    'q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p',
    'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l',
    'z', 'x', 'c', 'v', 'b', 'n', 'm',
    'backspace', 'delete', 'enter'
  ]
  
  render() {
    document.body.className = this.state.theme;
    const {word} = this.props;
    const wordLines = this.state.attempts.map((currentAttempt, index) => {
      return (
        <WordLine currentAttempt={currentAttempt} word={word} key={index} index={index} attempt={this.state.attempt}/>
      );
    });

    return (
      <div class="App">
        <div class="show-help" onClick={this.openHelp}><i class="fas fa-question-circle"></i></div>
        <div class="show-scores" onClick={this.openScores}><i class="fas fa-trophy"></i></div>
        { 
          this.state.user_update_version < this.state.update_version ? 
          <div class="show-updates show-updates--update" onClick={this.openUpdates}><i class="fas fa-bullhorn"></i></div> :
          <div class="show-updates" onClick={this.openUpdates}><i class="fas fa-bullhorn"></i></div>
        }
        <div class="discord">
          <a href="https://discord.gg/rBt3ngW6Bz" rel="noreferrer" target="_blank">
            <i class="fab fa-discord"></i>
          </a>
        </div>
        {/* <div class="refresh" onClick={() => {window.location = window.location.href.split("?")[0];}}><i class="fas fa-sync-alt"></i></div> */}
        <h1>GUMMIDGE</h1>
        {wordLines}
        <KeyboardEventHandler
          handleKeys={this.handleKeys}
          onKeyEvent={this.keyDownHandler} />
        <Keyboard onPressKey={this.pressKey} success={this.state.success} complete={this.state.complete} attempts={this.state.attempts} word={word} attempt={this.state.attempt} wordID={this.props.wordID}/>
        <Scores 
          scores={this.state.scores} 
          showScores={this.state.showScores} 
          hideScores={this.closeScores} 
          points={this.state.points} 
          theme={this.state.theme}
          buyTheme={this.buyTheme}
          setTheme={this.setTheme}
        />
        <Help showHelp={this.state.showHelp} hideHelp={this.closeHelp}/>
        <Updates showUpdates={this.state.showUpdates} hideUpdates={this.closeUpdates}/>
      </div>
    )
  }
}

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

export default App;
